/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */

/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/explorable-exercise/v1.ts
 */
import { createValidator } from '../../helpers/validator';
export var ExplorableExerciseV1Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    language: {
      type: 'string',
      enum: ['r', 'python', 'revo', 'sql', 'shell', 'scala', 'julia', 'containers']
    },
    runtime_config: {
      type: 'string'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    question: {
      anyOf: [{
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['Open'],
            default: 'Open'
          },
          items: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                question: {
                  type: 'string'
                },
                solution: {
                  type: 'object',
                  properties: {
                    answer: {
                      type: 'string'
                    },
                    message: {
                      type: 'string'
                    },
                    pattern: {
                      type: 'string'
                    }
                  },
                  required: ['answer', 'message', 'pattern']
                },
                feedback: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      message: {
                        type: 'string'
                      },
                      pattern: {
                        type: 'string'
                      }
                    },
                    required: ['message', 'pattern']
                  }
                }
              },
              required: ['question', 'solution', 'feedback']
            }
          }
        },
        required: ['flavor', 'items']
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['MultipleChoice'],
            default: 'MultipleChoice'
          },
          possible_answers: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          pre_exercise_code: {
            type: 'string',
            default: ''
          },
          question: {
            type: 'string',
            default: ''
          },
          sct: {
            type: 'string',
            default: ''
          }
        },
        required: ['flavor', 'possible_answers', 'pre_exercise_code', 'sct'],
        title: 'MultipleChoiceQuestion'
      }]
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'hint', 'language', 'question', 'title', 'xp'],
  definitions: {}
};
export var isValidExplorableExerciseV1 = createValidator(ExplorableExerciseV1Schema);
export var ExplorableExerciseV1Definition = {
  schema: ExplorableExerciseV1Schema,
  validate: isValidExplorableExerciseV1
};